import { PreviewSupportedFileType } from '$shared/constants/PreviewSupportedFileType';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import File from '$provider/models/File';

export class FilePreview<T> {
  public type: PreviewSupportedFileType;
  public data: T;

  constructor(type: PreviewSupportedFileType, data: T) {
    this.type = type;
    this.data = data;
  }

  public get isPdf(): boolean {
    return this.type === PreviewSupportedFileType.Pdf;
  }

  public get isImage(): boolean {
    return this.type === PreviewSupportedFileType.Image;
  }

  public get isCsv(): boolean {
    return this.type === PreviewSupportedFileType.Csv;
  }

  static validateSupportedMimeType(type: string | null): void {
    if (!type) throw new Error(UIErrorMessage.InvalidFileType);

    if (!File.checkMimeTypeSupportsPreview(type))
      throw new Error(UIErrorMessage.UnsupportedPreviewFileType);
  }
}
